import React from 'react';
import TextBox from '../../Basic/TextBox';
import SectionHeader from '../../Basic/SectionHeader';
const BuildingFootage = ({ isDuplex, address, nameExt }) => {
    const lookup = window.osa.lookup.projectSpecifics.buildingFootage;
    let name = "buildingFootage" + (nameExt || "");
    let title = lookup.title;
    if (isDuplex) {
        title = lookup.titleDuplex.replace('{Address}', address);
    }
    return (
        <div>
            <SectionHeader title={title} />
            <div className="row">
                <div className="col-sm-3">
                    <TextBox name={name} placeholder="0" />
                </div>
            </div>
        </div>
    );
};
BuildingFootage.propTypes = {
    isDuplex: React.PropTypes.bool,
    address: React.PropTypes.string,
    nameExt: React.PropTypes.string,
};
export default BuildingFootage;